<template>
  <div class="container">
    <img src="../../assets/Escape/budapest.png" class="image" />
    <img src="../../assets/Escape/map.png" class="elements" id="map" @click="toggleMap" />
    <img src="../../assets/Escape/note.png" class="elements" id="note" @click="toggleNote" />
    <transition name="fade">
      <BudapestIntro
        v-if="displayBudapestIntro"
        class="modale"
        @close="displayBudapestIntro = false"
      />
      <BudapestNote
        v-if="displayBudapestNote"
        class="modale"
        @close="displayBudapestNote = false"
        @next="toggleCode"
      />
    </transition>
    <div class="center">
      <transition name="fade">
        <Code
          v-if="displayCode"
          class="modale"
          @close="displayCode = false"
          @next="$emit('goToPartThree')"
          :title="'Quel est le nom du bâtiment en hongrois ?'"
          :password="'DIADALIV'"
        />
        <BudapestMap
          v-if="displayBudapestMap"
          class="modale-map"
          @close="displayBudapestMap = false"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import BudapestIntro from "./BudapestIntro.vue";
import BudapestMap from "./BudapestMap.vue";
import BudapestNote from "./BudapestNote.vue";
import Code from "./Code.vue";

export default {
  name: "Budapest",
  components: {
    BudapestIntro,
    BudapestMap,
    BudapestNote,
    Code
  },
  data() {
    return {
      displayBudapestIntro: true,
      displayBudapestNote: false,
      displayBudapestMap: false,
      displayCode: false
    }
  },
  methods: {
    toggleNote() {
      this.displayBudapestMap = false
      this.displayCode = false
      this.displayBudapestIntro = false
      this.displayBudapestNote = this.displayBudapestNote ? false : true
    },
    toggleCode() {
      this.displayBudapestMap = false
      this.displayBudapestIntro = false
      this.displayBudapestNote = false
      this.displayCode = true
    },
    toggleMap() {
      this.displayBudapestIntro = false
      this.displayCode = false
      this.displayBudapestNote = false
      this.displayBudapestMap = this.displayBudapestMap ? false : true
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
}
.image {
  object-fit: contain;
  overflow: scroll;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 40%;
  cursor: zoom-in;
}
.modale {
  position: absolute;
  top: 10%;
  height: auto;
  max-height: 75%;
  right: 25%;
  width: 50%;
}
.modale-map {
  position: absolute;
  top: 10%;
  height: auto;
  max-height: 90%;
  width: auto;
}
.elements:hover {
  opacity: 0.8;
  cursor: zoom-in;
}
#map {
  position: absolute;
  bottom: 14%;
  left: 24%;
  height: 10%;
}
#note {
  position: absolute;
  bottom: 14%;
  right: 56%;
  height: 10%;
}
</style>
